<template>
  <div class="modal fade in" v-if="open">
    <div class="modal-dialog" @click.stop>
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" @click="open = false">
            <i class="fa fa-times"></i>
          </button>
          <h4 class="modal-title">Logout Confirmation</h4>
        </div>
        <div class="modal-body">
          <p>Are you sure you want to logout?</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn" @click="open = false">
            Cancel
          </button>
          <span class="btn btn-primary" @click="logout()">Yes, I am sure</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ActsAsModal from 'mixins/ActsAsModal';

export default {
  mixins: [ActsAsModal],

  methods: {
    logout() {
      window.location = process.env.REAUTH_URL;
    },
  },
};
</script>



// WEBPACK FOOTER //
// LogoutConfirmation.vue?5577733b